module.exports = __webpack_public_path__ + "static/media/SF-2-if-wrong.59174584.mp3";